import { createStore } from "zustand"

export type SyncStatus = "idle" | "syncing" | "disconnected"

type SyncStatusState = {
  status: SyncStatus
  setStatus: (status: SyncStatus) => void
}

export const syncStatusStore = createStore<SyncStatusState>((set) => ({
  status: "idle",
  setStatus: (status) => set({ status }),
}))
